import { initializeApp } from 'firebase/app'
import { getDatabase } from 'firebase/database'
import { getAuth } from 'firebase/auth'

// Production config is baked in via .env.production (loaded at build time).
// For local dev, copy .env.example to .env.local and fill in the same values.
const config = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

if (!config.databaseURL) {
  // eslint-disable-next-line no-console
  console.warn('[firebase] VITE_FIREBASE_DATABASE_URL missing. Copy .env.example to .env.local and fill it in.')
}

export const app = initializeApp(config)
export const db = getDatabase(app)
export const auth = getAuth(app)
